// components/SweepButton.js

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DECIMAL } from "../../config";
import { cartBuyHandle } from "../../api/index";
import { cartBuy } from "../../utils/api";
import { useSigningCosmWasmClient } from "@sei-js/react";
import { toast } from "react-toastify";

const SweepButton = () => {
  const { signingCosmWasmClient: signingClient } = useSigningCosmWasmClient();
  const { trendingCategoryItemData, seiWallet } = useSelector(
    (state) => state.marketplace
  );

  const [selectedItems, setSelectedItems] = useState([]);
  const [buyAmount, setBuyAmount] = useState(0);
  const [price, setPrice] = useState(calculateTotalPrice(selectedItems));
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    setPrice(calculateTotalPrice(selectedItems));
  }, [selectedItems]);

  const handleToggle = () => {
    setShowSettings(!showSettings);
  };

  const handleRangeChange = (e) => {
    const selectedCount = parseInt(e.target.value, 10);
    setBuyAmount(selectedCount);
    setSelectedItems(trendingCategoryItemData.slice(0, selectedCount));
  };

  const handleChangeInput = e => {
   setBuyAmount(e.target.value) 
   setSelectedItems(trendingCategoryItemData.slice(0, e.target.value));
  }

  function calculateTotalPrice(selectedItems) {
    let result = selectedItems.reduce((total, item) => {
      const itemPrice = item?.price ? Number(Number(item?.price) / DECIMAL) : 0;
      return total + itemPrice;
    }, 0);

    return result.toFixed(3);
  }

  const sweepBuyButton = async () => {
    if (!seiWallet) {
      return toast.warning("Please connect the wallet", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }
    console.log("sweep cart: ", selectedItems);
    if (selectedItems.length <= 0) {
      return toast.warning("Empty Item", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 3000,
      });
    }

    let id = toast.loading("Buying...", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });

    const res = await cartBuyHandle(signingClient, seiWallet, selectedItems);
    if (res.success) {
      await cartBuy(selectedItems);
      toast.update(id, {
        render: "Bought successfully",
        type: "success",
        autoClose: 2000,
        isLoading: false,
      });
    } else {
      toast.update(id, {
        render: "Got Error",
        type: "warning",
        autoClose: 2000,
        isLoading: false,
      });
    }
  };

  return (
    <div className="flex flex-wrap mt-4 py-2 justify-between dark:border-jacarta-600 dark:bg-jacarta-700 group border-jacarta-100 font-display text-jacarta-700 items-center rounded-lg border bg-white px-4 text-sm font-semibold transition-colors hover:border-transparent hover:text-white dark:text-white">
      <div className=" flex items-center">
        <div className="flex items-center mr-4">
          <svg
            fill="#ffffff"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
            stroke="#ffffff"
            className="mr-3"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path d="M 28.28125 2.28125 L 18.28125 12.28125 L 17 11 L 17 10.96875 L 16.96875 10.9375 C 16.328125 10.367188 15.492188 10.09375 14.6875 10.09375 C 13.882813 10.09375 13.105469 10.394531 12.5 11 L 12.34375 11.125 L 11.84375 11.625 L 11.5 11.90625 L 2.375 19 L 1.5 19.71875 L 12.28125 30.5 L 13 29.625 L 20.0625 20.5625 L 20.09375 20.59375 L 21.09375 19.59375 L 21.125 19.59375 L 21.15625 19.5625 C 22.296875 18.277344 22.304688 16.304688 21.09375 15.09375 L 19.71875 13.71875 L 29.71875 3.71875 Z M 14.6875 12.09375 C 14.996094 12.085938 15.335938 12.191406 15.59375 12.40625 C 15.605469 12.414063 15.613281 12.429688 15.625 12.4375 L 19.6875 16.5 C 20.0625 16.875 20.097656 17.671875 19.6875 18.1875 C 19.671875 18.207031 19.671875 18.230469 19.65625 18.25 L 19.34375 18.53125 L 13.5625 12.75 L 13.90625 12.40625 C 14.097656 12.214844 14.378906 12.101563 14.6875 12.09375 Z M 12.03125 14.03125 L 17.96875 19.96875 L 12.09375 27.46875 L 10.65625 26.03125 L 12.8125 23.78125 L 11.375 22.40625 L 9.25 24.625 L 7.9375 23.3125 L 11.8125 19.40625 L 10.40625 18 L 6.5 21.875 L 4.53125 19.90625 Z"></path>
            </g>
          </svg>
          <label className="mr-3 text-gray-600">Sweep</label>
          <span className="h-10 w-[2px] bg-jacarta-600 mr-3"></span>
          <input
            type="range"
            min="0"
            max={trendingCategoryItemData.length}
            value={buyAmount}
            onChange={handleRangeChange}
            className="appearance-none w-40 h-2 bg-gray-300 rounded-full"
          />
        </div>

        <div className="flex items-center space-x-3 px-5">
          <input
            type="number"
            min={0}
            max={trendingCategoryItemData.length}
            placeholder="0"
            value={buyAmount}
            onChange={handleChangeInput}
            className="text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full max-w-[7.5rem] rounded-lg border py-[0.6875rem] px-4 dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
          />
        </div>
      </div>

      <div className="sweep_btn_box">
        <button
          className="bg-accent shadow-accent-volume flex justify-center items-center hover:bg-accent-dark w-30 rounded-full py-2 px-6 text-center font-semibold text-white transition-all"
          onClick={sweepBuyButton}
        >
          <span className="mr-2">Buy</span>{" "}
          <span className="mr-2">{buyAmount}</span>{" "}
          <span className="mr-2">items for</span>{" "}
          <span className="mr-2">{price} SEI</span>
        </button>
      </div>
    </div>
  );
};

export default SweepButton;
